<template>
  <v-dialog v-model="show" persistent max-width="590px">
    <v-card>
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-form v-model="isValid">
            <v-row>
              <v-col>
                <v-text-field v-model="periodoAnterior.MEDIO" label="Medio" outlined dense readonly />
              </v-col>
              <v-col>
                <v-text-field v-model="periodoAnterior.TIPO" label="Tipo" outlined dense readonly />
              </v-col>
              <!--<v-layout column>
                <v-flex xs12 sm6 md6>
                  <v-text-field label="Reincorporación" v-model="fechaReincorporacion" readonly></v-text-field>
                </v-flex>
              </v-layout>-->
            </v-row>

            <v-row dense>
              <v-col>
                <!--<v-text-field label="Reincorporación" v-model="fechaReincorporacion" readonly></v-text-field>-->
                <span v-show="errorReincorporacion" style="color:red">Esta reincorporación no cumple con los tiempos calculados.</span>

                <vx-date-text-edit v-model="inicioJornada" label="Inicio jornada" outlined dense required />
                <!-- <VueCtkDateTimePicker id="inicioJornadaActDatePicker"
                                    label="Inicio jornada"
                                    color="#00759e"
                                    format="YYYY-MM-DD HH:mm"
                                    noClearButton
                                    overlay
                                    position="bottom"
                                    :error="this.errorDate"
                                    v-on:is-shown="abrirDatePicker('inicioJornadaActDatePicker')"
                                    v-on:is-hidden="cerrarDatePicker('inicioJornadaActDatePicker')"
                                    button-now-translation="Ahora"
                                    v-model="inicioJornada"
                                    ref="inicioJornadaActDatePicker">
                </VueCtkDateTimePicker> -->
              </v-col>
              <v-col>
                <vx-date-text-edit v-model="fechaReincorporacion" label="Reincorporación" outlined dense required />
                <!-- <VueCtkDateTimePicker id="reincorporacionDatePicker"
                                    label="Reincorporación"
                                    color="#00759e"
                                    format="YYYY-MM-DD HH:mm"
                                    noClearButton
                                    overlay
                                    position="bottom"
                                    button-now-translation="Ahora"
                                    v-model="fechaReincorporacion"
                                    :error="this.errorReincorporacion"
                                    v-on:is-shown="abrirDatePicker('reincorporacionDatePicker')"
                                    v-on:is-hidden="cerrarDatePicker('reincorporacionDatePicker')"
                                    ref="reincorporacionDatePicker"/> -->
              </v-col>
              <v-col>
                <vx-date-text-edit v-model="fechaLlegadaEmergenciaCalculada" label="Llegada a incendio" outlined dense required />
                <!-- <VueCtkDateTimePicker id="llegadaIncendioDatePicker"
                                    label="Llegada a incendio"
                                    color="#00759e"
                                    format="YYYY-MM-DD HH:mm"
                                    noClearButton
                                    overlay
                                    position="bottom"
                                    button-now-translation="Ahora"
                                    v-model="fechaLlegadaIncendioCalculada"
                                    :error="this.errorDate"
                                    v-on:is-shown="abrirDatePicker('llegadaIncendioDatePicker')"
                                    v-on:is-hidden="cerrarDatePicker('llegadaIncendioDatePicker')"
                                    ref="llegadaIncendioDatePicker"/> -->
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <v-text-field v-model="horasOperativo" label="Tiempo operativo (horas)" type="number" :min="1" outlined dense :rules="[globalRules.required]" />
              </v-col>
              <v-col>
                <v-text-field v-model="horasDescanso" label="Tiempo descanso (horas)" type="number" :min="1" outlined dense :rules="[globalRules.required]" />
              </v-col>

              <v-col>
                <v-text-field v-model="numComponentes" label="Nº componentes" type="number" :min="1" outlined dense :rules="[globalRules.required]" />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <v-select v-model="sectorSelected" :items="sectores" label="Sector" outlined dense item-text="SECTOR" item-value="ID_SECTOR" return-object autocomplete :rules="[globalRules.required]" />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text color="red" @click="cancelar">Cancelar</v-btn>
        <v-btn text color="green darken-1" :disabled="!isValid" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constants from '@/helpers/constants'
import DateService, { FMT, DayjsUnit } from '@/helpers/DateService'

export default {
  name: 'DialogAddActuacionMMTT',

  props: {
    show: Boolean,
    isEdit: Boolean,
    editedItem: {
      type: Object,
      default: () => { return {} }
    },
    periodoAnterior: {
      type: Object,
      default: () => { return {} }
    },
    sectores: Array
  },

  data: () => ({
    titulo: 'Añadir actuación al medio',
    isValid: false,

    errorReincorporacion: false,

    numComponentes: 1,
    fechaReincorporacion: null,
    fechaLlegadaEmergenciaCalculada: null,
    horasOperativo: 17,
    horasDescanso: 12,

    // Primera incorporacion
    inicioJornada: null,
    horaMovilizacion: null,
    horaLlegadaInc: null,
    sectorSelected: null
  }),

  computed: {
    medios () {
      return this.$store.getters.getMedios.filter(x => x.CLASE !== constants.maestras.CLASE.MEDIO_AEREO.ID_CLASE).sort((a, b) => {
        return a.MEDIO - b.MEDIO
      })
    }
  },

  watch: {
    show () {
      if (this.show) {
        if (this.isEdit) {
          this.titulo = 'Editar actuación'

          this.numComponentes = this.editedItem.NUM_COMPONENTES
          this.sectorSelected = this.editedItem.SECTOR

          this.inicioJornada = this.$date.parseDate(this.editedItem.INICIO_JORNADA).format(FMT.date)
          this.horasOperativo = this.editedItem.TIEMPO_OPERATIVO
          this.horasDescanso = this.editedItem.TIEMPO_DESCANSO
        } else {
          this.titulo = 'Añadir actuación al medio'

          this.numComponentes = 1

          this.horasOperativo = parseInt(this.$store.getters['parametro/getParametro']('DEFAULT_TIEMPO_ACTUACION'))
          this.horasDescanso = parseInt(this.$store.getters['parametro/getParametro']('DEFAULT_TIEMPO_DESCANSO'))

          /* let fechaIncorporacion = moment().locale('es').format('YYYY-MM-DD')
            let horaEntrada = moment(this.periodoAnterior.INICIO_JORNADA).locale('es').format('HH:mm')
            this.inicioJornada = moment(fechaIncorporacion + ' ' + horaEntrada).locale('es').format('YYYY-MM-DD HH:mm') */
        }
      }
    },

    fechaReincorporacion () {
      if (!this.isEdit) {
        this.errorReincorporacion = this.periodoAnterior.FECHA_FIN_DESCANSO && (this.fechaReincorporacion !== this.periodoAnterior.FECHA_FIN_DESCANSO.format(FMT.date))
      }
    },

    sectores () {
      this.sectorSelected = this.sectores[0]
    },

    periodoAnterior () { // Cuando cambia (lo ha recibido), copiarlo a otro elemento para no sobreescribir
      this.numComponentes = this.periodoAnterior.NUM_COMPONENTES

      if (this.isEdit) {
        this.fechaReincorporacion = this.editedItem.HORA_MOVILIZACION.format(FMT.date)
        this.fechaLlegadaEmergenciaCalculada = this.editedItem.HORA_LLEGADA_INC.format(FMT.date)
      } else {
        if (this.periodoAnterior.FECHA_FIN_DESCANSO) {
          this.fechaReincorporacion = this.periodoAnterior.FECHA_FIN_DESCANSO.format(FMT.date) // DD/MM/YYYY HH:mm

          let fechaIncorporacion = this.$date.parseDate(this.fechaReincorporacion).format(FMT.onlyDate)
          let horaEntrada = this.$date.parseDate(this.periodoAnterior.INICIO_JORNADA).format(FMT.time)
          this.inicioJornada = this.$date.parseDate(fechaIncorporacion + ' ' + horaEntrada).format(FMT.date)

          let itinere = this.periodoAnterior.FECHA_LLEGADA_BASE.diff(this.periodoAnterior.FECHA_SALIDA_INC, DayjsUnit.Minute) // FECHA_MAX_ACTUACION
          this.fechaLlegadaEmergenciaCalculada = this.$date.parseDate(this.fechaReincorporacion).add(itinere, DayjsUnit.Minute).format(FMT.date)
        }
      }
    }
  },

  filters: {
    fechahora (value) {
      if (value) {
        return this.$date.parseDate(value).format(FMT.date)
      }
    }
  },

  methods: {
    cancelar () {
      this.$emit('cancelar')
    },

    aceptar () {
      let horaLlegadaInc = this.$date.parseDate(this.fechaLlegadaEmergenciaCalculada)
      let inicioJornada = this.$date.parseDate(this.inicioJornada)

      if (!this.isEdit) { // Insertar nuevo
        let tiempoLlegadaEmergencia = this.$date.parseDate(this.periodoAnterior.FECHA_LLEGADA_BASE).diff(this.$date.parseDate(this.periodoAnterior.FECHA_MAX_ACTUACION, FMT.time), DayjsUnit.Minute)

        // let horaLlegadaInc = moment(this.fechaReincorporacion).add(tiempoLlegadaIncendio, 'minutes') // moment(this.periodoAnterior.FECHA_FIN_DESCANSO).add(tiempoLlegadaIncendio, 'minutes')
        // let fechaMaximaActuacion = moment(this.fechaReincorporacion).add(this.horasOperativo, 'hours')
        let fechaMaximaActuacion = this.$date.parseDate(this.inicioJornada).add(this.horasOperativo, DayjsUnit.Hour)
        let fechaSalidaInc = this.$date.parseDate(fechaMaximaActuacion).subtract(tiempoLlegadaEmergencia, DayjsUnit.Minute)
        let fechaLlegadaBase = this.$date.parseDate(fechaMaximaActuacion) // .add(tiempoLlegadaIncendio, DayjsUnit.Minute) // TODO: salida confirmada
        let fechaFinDescanso = this.$date.parseDate(fechaLlegadaBase).add(this.horasDescanso, DayjsUnit.Hour) // TODO: llegada base confirmada

        let data = {
          ID_MEDIO: this.periodoAnterior.ID_MEDIO,
          ID_MEDIO_SECTOR: this.$uuid.createUUID(),
          MEDIO: this.periodoAnterior.MEDIO,
          ACTUACION: this.periodoAnterior.ACTUACION + 1,
          TIPO: this.periodoAnterior.TIPO,
          SECTOR: this.sectorSelected,
          NUM_COMPONENTES: this.numComponentes === '' ? '1' : this.numComponentes,
          INICIO_JORNADA: inicioJornada, // this.inicioJornada,
          TIEMPO_OPERATIVO: this.horasOperativo,
          TIEMPO_DESCANSO: this.horasDescanso,
          FECHA_INCORPORACION: this.$date.parseDate(this.fechaReincorporacion).format('YYYY/MM/DD'), // moment(this.periodoAnterior.FECHA_FIN_DESCANSO).format('YYYY/MM/DD'),
          HORA_MOVILIZACION: this.$date.parseDate(this.fechaReincorporacion), // moment(this.periodoAnterior.FECHA_FIN_DESCANSO),
          HORA_LLEGADA_INC: horaLlegadaInc,
          FECHA_SALIDA_INC: fechaSalidaInc,
          FECHA_MAX_ACTUACION: fechaMaximaActuacion,
          FECHA_LLEGADA_BASE: fechaLlegadaBase,
          FECHA_FIN_DESCANSO: fechaFinDescanso
        }
        this.$emit('aceptar', data)
      } else { // Editar
        let data = { // Todo tiene que ser igual que en item menos numComp y sector
          ID_MEDIO: this.editedItem.ID_MEDIO,
          ID_MEDIO_SECTOR: this.editedItem.ID_MEDIO_SECTOR,
          MEDIO: this.editedItem.MEDIO,
          ACTUACION: this.editedItem.ACTUACION,
          TIPO: this.editedItem.TIPO,
          SECTOR: this.sectorSelected,
          NUM_COMPONENTES: this.numComponentes === '' ? '1' : this.numComponentes,
          INICIO_JORNADA: inicioJornada, // this.inicioJornada,
          TIEMPO_OPERATIVO: this.horasOperativo,
          TIEMPO_DESCANSO: this.horasDescanso,
          FECHA_INCORPORACION: this.$date.parseDate(this.fechaReincorporacion).format(FMT.onlyDate), // moment(this.editedItem.FECHA_FIN_DESCANSO).format('YYYY/MM/DD'),
          HORA_MOVILIZACION: this.$date.parseDate(this.fechaReincorporacion), // moment(this.editedItem.FECHA_FIN_DESCANSO),
          HORA_LLEGADA_INC: horaLlegadaInc, // this.editedItem.HORA_LLEGADA_INC,
          FECHA_SALIDA_INC: this.editedItem.fechaSalidaInc,
          FECHA_MAX_ACTUACION: this.editedItem.FECHA_MAX_ACTUACION,
          FECHA_LLEGADA_BASE: this.editedItem.FECHA_LLEGADA_BASE,
          FECHA_FIN_DESCANSO: this.editedItem.FECHA_FIN_DESCANSO
        }
        this.$emit('editar', data)
      }
    }
  },

  mounted () {
  }
}
</script>

<style scoped>
</style>
